<script>
//DateRange.vue

export default {
    props: {
        facetTitle: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        limitOptions: {
            type: Number,
            required: true
        },
        value: {
            type: String,
        },
        filterOptions: {
            type: Boolean,
            default: false,
        },
        showCounts: {
            type: Boolean,
            default: true,
        },
        group: Boolean
    },
    data() {
        return {
            id: _.uniqueId(),
            selectedValue: this.value ?? null,
            config: {
                defaultDate: null,
                dateFormat: 'Y-m-d',
            },
            userCollapsed: false,
        }
    },
    computed: {
        selectedValueFrom: {
            get() {
                if (this.selectedValue) {
                    let dates = this.selectedValue.split('~');
                    return dates[0] ? dates[0] : '';
                }

                return '';
            },
            set(value) {
                this.selectedValue = value + '~' + this.selectedValueTo;
            }
        },
        selectedValueTo: {
            get() {
                if (this.selectedValue) {
                    let dates = this.selectedValue.split('~');
                    return dates[1] ? dates[1] : '';
                }

                return '';
            },
            set(value) {
                this.selectedValue = this.selectedValueFrom + '~' + value;
            }
        },
    },
    methods: {
        toggleFacet() {
            this.showFacet = !this.showFacet
        },
        reset() {
            this.selectedValue = null;
        }
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue ?? null;
        },
        selectedValue(value) {
            if (value === '~') {
                this.selectedValue = value = null;
            }

            this.$emit('input', value);
        },
    }
}
</script>

<template>
    <div>

        <div class="search-wrapper">
            <div class="form-group row">
                <div class="col-xs-5">
                    <label :for="'from'+id">Von</label>
                    <flat-pickr
                        :id="'from'+id"
                        class="form-control"
                        ref="input"
                        :config="config"
                        v-model="selectedValueFrom"
                    />
                </div>
                <div class="col-xs-5">
                    <label :for="'to'+id">Bis</label>
                    <flat-pickr
                        :id="'to'+id"
                        class="form-control"
                        ref="input"
                        :config="config"
                        v-model="selectedValueTo"
                    />
                </div>
                <div class="col-xs-2 reset">
                    <button @click="reset()" class="btn btn-xs btn-default"><i class="fa fa-eraser"></i>
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
.dateRange {
    padding: 4px;
    margin: 0;
}

.title {
    cursor: pointer;
    font-weight: bold;
    color: #7a797b;
}

.title span i {
    margin-left: 5px;
    color: #c4c4c4;
}

.search-wrapper {

}

.reset button {
    margin-top: 26px;
}

.reset button i {
    color: #c4c4c4;
}

</style>
